import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';

import type { StudioParams } from '../../shared/panels/swatchSelection';

interface Props {
  studioParams?: StudioParams;
  /** Optional inline hint shown in italic when present (e.g. for read-only
   *  panels: "this op ignores swatches"). */
  hint?: string;
}

/**
 * Renders the "Studio: Photoreal · 16:9 · Moody" chip row used under the
 * prompt input of every Generic-Studio operation panel. Read-only — clicking
 * a chip is intentionally inert (selections are owned by the SwatchPanel).
 *
 * Returns null when no chips are active so the panel layout collapses cleanly.
 */
export const StudioSwatchChips: React.FC<Props> = ({ studioParams, hint }) => {
  if (!studioParams || studioParams.chipLabels.length === 0) return null;
  return (
    <Stack
      direction="row"
      spacing={0.5}
      flexWrap="wrap"
      alignItems="center"
      sx={{ rowGap: 0.5 }}
      aria-label="Active Studio swatches"
    >
      <Typography variant="caption" color="text.secondary">
        Studio:
      </Typography>
      {studioParams.chipLabels.map(label => (
        <Chip key={label} label={label} size="small" variant="outlined" />
      ))}
      {hint && (
        <Typography variant="caption" color="text.secondary" fontStyle="italic" sx={{ ml: 0.5 }}>
          {hint}
        </Typography>
      )}
    </Stack>
  );
};
